import Dashboard, { CTAStart, NewsBar } from 'app/developer-v3/pages/dashboard';

export { CTAStart, NewsBar };

export default {
  isAuthRequired: true,
  routes: {
    '.': Dashboard,
  },
};
